(function() {
  'use strict';

  function SlotController($scope, $translate, Security) {
    var ctrl = this;

    ctrl.shownAnswer = false;
    ctrl.showAnswer = function() {
      ctrl.shownAnswer = !ctrl.shownAnswer;
    };

    // this may be also used for the details view, move it if necessary
    ctrl.actionButtons = [
      {
        label: $translate.instant('Show answer'),
        icon: 'icon-edit',
        onClick: ctrl.showAnswer,
        klass: 'text-info'
      },
      {
        label: $translate.instant('Edit'),
        icon: 'icon-edit',
        route: ['/faqs/edit', $scope.item._id],
        showCondition: Security.hasPermission.bind(this, 'faqs.edit'),
        klass: 'text-info'
      }
    ];
  }

  SlotController.$inject = ['$scope', '$translate', 'SecurityService'];

  function SlotDirective() {
    return {
      scope: {
        item: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/faqs/faq.slot.html',
      controller: SlotController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('component.goals')
    .directive('faqSlot', SlotDirective)
    .controller('faqSlotController', SlotController);
})();
